module.exports = __webpack_public_path__ + "img/bingo_ball-4.6c50a923.png";